import { useEffect, useState } from 'react';

import useFlagOrganization from '../useFlagOrganization';

interface useConditionalQueryProps {
  getData: () => void;
  getDataLegacy: () => void;
  featureFlag: string;
}

const useConditionalQuery = ({
  getDataLegacy,
  getData,
  featureFlag,
}: useConditionalQueryProps) => {
  const { isActive, isLoading } = useFlagOrganization({
    flag: featureFlag,
  });
  const [localLoading, setLocalLoading] = useState(true);
  const [calledFeatureFlag, setCalledFeatureFlag] = useState(false);

  useEffect(() => {
    if (isLoading) {
      setCalledFeatureFlag(true);
    }
    if (!isLoading && calledFeatureFlag) {
      setLocalLoading(false);
    }
  }, [isLoading, calledFeatureFlag]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (localLoading) return;
    if (isActive) {
      getData();
    } else {
      getDataLegacy();
    }
  }, [localLoading, isActive]);

  return {
    isLoading: isLoading || localLoading,
    isActive,
  };
};

export default useConditionalQuery;
